import { NgModule } from '@angular/core';
import { NouisliderComponent } from './ng2-nouislider.component';

@NgModule({
  exports: [NouisliderComponent],
  imports: [NouisliderComponent],
})
export class NouisliderModule {}
